import { render, staticRenderFns } from "./genel.vue?vue&type=template&id=ebe4e0f4&scoped=true&"
import script from "./genel.vue?vue&type=script&lang=js&"
export * from "./genel.vue?vue&type=script&lang=js&"
import style0 from "./genel.vue?vue&type=style&index=0&id=ebe4e0f4&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ebe4e0f4",
  null
  
)

export default component.exports